import { render, staticRenderFns } from "./AddCarRegistrationData.vue?vue&type=template&id=149d2ecf&"
import script from "./AddCarRegistrationData.vue?vue&type=script&lang=js&"
export * from "./AddCarRegistrationData.vue?vue&type=script&lang=js&"
import style0 from "./AddCarRegistrationData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddCarRegistrationData.vue"
export default component.exports